// ============================================================================
// Pig daily report: "Was group moved?" must be answered (owner request
// 2026-11-04)
// ============================================================================
//
// The question used to start at Yes. It now starts blank (null) and the person
// must pick Yes or No before submitting. This check is enforced in the form
// regardless of the admin's required-field config, because
// submit_queued_report fills group_moved = true when the key is missing
// (229_queued_report_receipts.sql), so a blank answer must never reach the
// server: every payload carries an explicit true or false.
// ============================================================================

export const GROUP_MOVED_REQUIRED_MESSAGE = 'Please answer "Was group moved?" (Yes or No).';

/** True only for an explicit Yes or No answer. */
export function groupMovedAnswered(value: unknown): value is boolean {
  return value === true || value === false;
}

/** The YN control's value: null (nothing highlighted) unless explicitly answered. */
export function groupMovedChoice(value: unknown): boolean | null {
  return groupMovedAnswered(value) ? value : null;
}

/**
 * The refusal message for a pig report whose rows are not all answered, or
 * null when every row has an explicit answer. `rows` carries each row's label
 * (for the message) and its groupMoved value.
 */
export function groupMovedRefusal(rows: ReadonlyArray<{label?: string | null; groupMoved: unknown}>): string | null {
  const missing = rows.filter((r) => !groupMovedAnswered(r.groupMoved));
  if (missing.length === 0) return null;
  const named = missing.map((r) => (r.label || '').trim()).filter(Boolean);
  return named.length > 0 && rows.length > 1
    ? `${GROUP_MOVED_REQUIRED_MESSAGE} Missing for: ${named.join(', ')}.`
    : GROUP_MOVED_REQUIRED_MESSAGE;
}
